import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const RefundPolicy = () => {
  return (
    <>
      <Header />

      <div
        className="container"
        style={{
          marginTop: "150px",
          marginBottom: "60px",
          maxWidth: "1000px",
        }}
      >
        {/* Hero Section */}
        <div
          className="text-center text-white p-5 rounded"
          style={{
            background:
              "linear-gradient(135deg, #6B2A00 0%, #E3952A 100%)",
          }}
        >
          <h1 className="fw-bold mb-3">
            Refund & Cancellation Policy
          </h1>

          <p className="mb-0">
            Please review our refund and cancellation
            policy before booking any service through
            Ez Puja Path.
          </p>
        </div>

        {/* Content */}
        <div
          className="bg-white shadow-sm rounded p-4 p-md-5 mt-4"
          style={{
            lineHeight: "1.9",
            color: "#444",
          }}
        >
          <p>
            <strong>Last Updated:</strong> June 2026
          </p>

          <p>
            At <strong>Ez Puja Path</strong>, we strive
            to provide the best spiritual and religious
            services. This Refund & Cancellation Policy
            outlines the terms under which cancellations,
            refunds, and service modifications are handled.
          </p>

          <h3 className="mt-4">
            1. Booking Cancellation
          </h3>

          <p>
            Users may request cancellation of a booking
            before the scheduled puja, consultation,
            or service begins.
          </p>

          <ul>
            <li>
              Cancellation requests must be submitted
              through our support team.
            </li>
            <li>
              Cancellation approval is subject to service
              status and provider availability.
            </li>
            <li>
              Once a service has commenced, cancellation
              may not be possible.
            </li>
          </ul>

          <h3 className="mt-4">
            2. Refund Eligibility
          </h3>

          <p>
            Refunds may be considered under the
            following circumstances:
          </p>

          <ul>
            <li>
              Service could not be provided by Ez Puja Path.
            </li>
            <li>
              Duplicate payment was made for the same booking.
            </li>
            <li>
              Technical errors resulting in unsuccessful service delivery.
            </li>
            <li>
              Verified payment issues caused by system malfunction.
            </li>
          </ul>

          <h3 className="mt-4">
            3. Non-Refundable Situations
          </h3>

          <p>
            Refunds will generally not be issued in the
            following situations:
          </p>

          <ul>
            <li>
              Services already delivered successfully.
            </li>
            <li>
              User-provided incorrect booking details.
            </li>
            <li>
              Failure to attend scheduled appointments.
            </li>
            <li>
              Change of personal preference after booking.
            </li>
            <li>
              Delays caused by circumstances beyond our control.
            </li>
          </ul>

          <h3 className="mt-4">
            4. Refund Processing Time
          </h3>

          <p>
            Approved refunds are generally processed
            within <strong>5–10 business days</strong>.
          </p>

          <p>
            The actual credit time may vary depending on
            your bank, card issuer, UPI provider, or
            payment gateway.
          </p>

          <h3 className="mt-4">
            5. Partial Refunds
          </h3>

          <p>
            In certain cases, only a partial refund may be
            issued if expenses have already been incurred
            for arrangements, preparations, materials,
            or service provider allocation.
          </p>

          <h3 className="mt-4">
            6. Failed Transactions
          </h3>

          <p>
            If your account is debited but the booking is
            not confirmed, please contact our support team.
          </p>

          <p>
            After verification, the amount may be
            automatically reversed or refunded as per
            payment gateway policies.
          </p>

          <h3 className="mt-4">
            7. Service Rescheduling
          </h3>

          <p>
            Subject to availability, certain services may
            be rescheduled instead of cancelled.
          </p>

          <p>
            Rescheduling requests should be made as early
            as possible before the scheduled service date.
          </p>

          <h3 className="mt-4">
            8. Contact for Refund Requests
          </h3>

          <p>
            For cancellation or refund-related inquiries,
            please contact:
          </p>

          <div
            className="p-4 rounded"
            style={{
              background: "#f8f9fa",
              borderLeft: "4px solid #E3952A",
            }}
          >
            <p className="mb-2">
              <strong>Ez Puja Path</strong>
            </p>

            <p className="mb-2">
              Email: info@ezpujapath.com
            </p>

            <p className="mb-2">
              Website: https://ezpujapaath.com
            </p>

            <p className="mb-0">
              Phone: +91 XXXXX XXXXX
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default RefundPolicy;